import { render, staticRenderFns } from "./WidgetDropdown.vue?vue&type=template&id=ab2ddcd8&"
import script from "./WidgetDropdown.vue?vue&type=script&lang=js&"
export * from "./WidgetDropdown.vue?vue&type=script&lang=js&"
import style0 from "./WidgetDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports